import dayjs from "dayjs";

import { settingsRepo } from "./settings.repo";
import {
  ICompanyObject,
  IObveznikRoleOption,
  IObveznikRoles,
  IUserDetails,
} from "./settings.types";

class SettingsService {
  getCompanyDetails = () => {
    return settingsRepo.getCompanyDetails();
  };

  getPromeniStatusEmailNotifikacija = (status: boolean) => {
    return settingsRepo.getPromeniStatusEmailNotifikacija(status);
  };

  getCompanyUsers = () => {
    return settingsRepo.getCompanyUsers();
  };

  getUsersDetails = (userId: string) => {
    return settingsRepo.getUsersDetails(userId);
  };

  addCompanyUser = (payload: IUserDetails) => {
    return settingsRepo.addCompanyUser(payload);
  };

  editCompanyUser = (payload: IUserDetails) => {
    return settingsRepo.editCompanyUser(payload);
  };

  getCompanyObjects = (aktivno?: boolean) => {
    return settingsRepo.getCompanyObjects(aktivno);
  };

  getObjectDetails = (objectId: number) => {
    return settingsRepo.getObjectDetails(objectId);
  };

  private parseCompanyObjectMasinePayload = (
    payload: ICompanyObject
  ): ICompanyObject => {
    return {
      ...payload,
      masine: payload.masine?.filter(
        (masina) => masina.model && masina.proizvodjac && masina.serijskiBroj
      ),
    };
  };

  addCompanyObject = (payload: ICompanyObject) => {
    return settingsRepo.addCompanyObject(
      this.parseCompanyObjectMasinePayload(payload)
    );
  };

  editCompanyObject = (payload: ICompanyObject) => {
    const validPayload: ICompanyObject = {
      ...payload,
      tipId: undefined,
      tip: payload.tipId as any,
    };
    return settingsRepo.editCompanyObject(
      this.parseCompanyObjectMasinePayload(validPayload)
    );
  };

  getApiSettings = () => {
    return settingsRepo.getApiSettings();
  };

  refreshApiKey = () => {
    return settingsRepo.refreshApiKey();
  };

  editNotificationEmail = (newEmail: string | undefined) => {
    return settingsRepo.editNotificationEmail(newEmail);
  };

  editNotificationStatus = (status: boolean) => {
    return settingsRepo.editNotificationActive(status);
  };

  // Mutations

  parseUserPayload = (user: IUserDetails): IUserDetails => {
    return {
      ...user,
      roles: user.roles.reduce<IObveznikRoles[]>((acc, role) => {
        return role.id
          ? [
              ...acc,
              {
                ...role,
                // @ts-ignore
                datumVazenjaDo: role.datumVazenjaDo
                  ? // @ts-ignore
                    dayjs(role.datumVazenjaDo, "DD.MM.YYYY").toISOString()
                  : null,
                // @ts-ignore
                datumVazenjaOd: role.datumVazenjaOd
                  ? // @ts-ignore
                    dayjs(role.datumVazenjaOd, "DD.MM.YYYY").toISOString()
                  : null,
              },
            ]
          : acc;
      }, []),
    };
  };

  parseUserRoles = (
    roles: IObveznikRoles[],
    obveznikRoles: IObveznikRoleOption[]
  ) => {
    return roles
      ?.map(
        (userRole) =>
          obveznikRoles.find((role) => userRole.id === role.id)?.name
      )
      ?.join(",");
  };
}

export const settingsService = new SettingsService();
